import { Component, inject, input } from '@angular/core';

import { EarlyPayoutUtils } from '../../../my-bets-base/early-payout/early-payout-utils';
import { MyBetsBetSlip, MyBetsListContext } from '../../../my-bets-base/models/my-bets-viewmodels';

@Component({
    selector: 'ms-my-bets-betslip-card-title-options',
    templateUrl: './my-bets-betslip-card-title-options.html',
})
export class MyBetBetslipCardTitleOptionsComponent {
    betslip = input.required<MyBetsBetSlip>();
    myBetsListContext = input.required<MyBetsListContext>();
    isBetSlipBadgeVisible = input.required<boolean>();

    private earlyPayoutUtils = inject(EarlyPayoutUtils);

    get isEditButtonVisible(): boolean {
        return this.earlyPayoutUtils.isEditButtonVisible(this.betslip(), this.myBetsListContext());
    }
}
